import fullColorBadge from '../../logo/nvidia-inception/nvidia-inception-program-badge-rgb-for-screen.svg?raw';
import { INCEPTION_BADGE_ALT, INCEPTION_PROGRAM_URL } from '../content/nvidia-inception';
import { EXTERNAL_LINK_ATTRS, NEW_TAB_NOTE } from '../lib/links';

/*
 * The artwork is used exactly as supplied: no recolouring, cropping, stretching or animation, and the artboard's
 * built-in clear space is kept. It is an <img> (not inline SVG) so the file's own styles stay isolated from the
 * page, and a data URI so it also works in the self-contained preview build.
 */
const FULL_COLOR_BADGE_SRC = `data:image/svg+xml,${encodeURIComponent(fullColorBadge.trim())}`;

/** The full-colour badge. Sized in CSS through `className`; height-only sizing keeps the aspect ratio. */
export const inceptionBadge = (className: string): string =>
  `<img class="${className}" src="${FULL_COLOR_BADGE_SRC}" alt="${INCEPTION_BADGE_ALT}" width="500" height="216" decoding="async">`;

/** The badge linking to NVIDIA's startup program in a new tab. */
export const inceptionBadgeLink = (className: string): string =>
  `<a class="${className}" href="${INCEPTION_PROGRAM_URL}" ${EXTERNAL_LINK_ATTRS}>${inceptionBadge('inception-badge')}${NEW_TAB_NOTE}</a>`;
